import { axiosRef } from '../../../api';

export default async function getProject(
  id: number,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  try {
    const response = await axiosRef.get(`/projects/${id}`);

    if (!response?.data?.is_error && response?.data?.content) {
      setLoading(false);
      const content = response.data.content;
      return {
        id: content?.id || -1,
        accountNumber: content?.account_number,
        code: content?.code,
        description: content?.description,
        endDate: content?.end_date,
        firstName: content?.first_name,
        lastName: content?.last_name,
        name: content?.name,
        owner: content?.owner,
        startDate: content?.start_date,
      };
    }
    setLoading(false);
    return { code: '' };
  } catch (error) {
    setLoading(false);
    return { code: '' };
  }
}